/* eslint-disable */


function scrollToHash() {
  if (window.location.hash) {
    var hash = window.location.hash;

    if (jQuery(hash).length) {
      jQuery('html, body').animate({ scrollTop: jQuery(hash).offset().top - 150 }, 250, 'linear');
    }
  }

  jQuery('a[href^="#"]').click(function (event) {
    if (this.hash !== '') {
      event.preventDefault();
      var hash = this.hash;
      if (jQuery(hash).length) {
        history.pushState({}, '', hash);
        jQuery('html, body').animate({ scrollTop: jQuery(hash).offset().top - 150 }, 250, 'linear');
      }
    }
  });
}


window.addEventListener('load', scrollToHash)